import { createSelector } from 'reselect';
import { updateProductNameDisplayHPSelector } from 'selectors/testTarget/offers/updateProductNameDisplayHP/updateProductNameDisplayHPSelector';

/**
 * Returns a boolean indicating whether the offer's `active` field is truthy.
 */
const activeSelector = createSelector(updateProductNameDisplayHPSelector, updateProductNameDisplayHP => !!updateProductNameDisplayHP.active);

export { activeSelector };
